import React from "react";
import { marked } from 'marked';

import styles from './style.css';

export const Message = ({ msg, index, isLast, dispatch }) => {
    const isThinking = msg.content.startsWith("_") && msg.content.endsWith("_")

    const seeMore = () => {
        let total = 0
        const interval = setInterval(() => {
            dispatch({type: "increaseScroll", scroll: 3})
            total += 3
            if (total >= 300)
                clearInterval(interval)
        }, 10)
    }

    /** Substring 0 to `until`, will not cut only in spaces. */
    const sensitiveSubstring = (str, until) => {
        if (str < until)
            return str

        const lastSpace = str.lastIndexOf('\n', until)
        return lastSpace == -1 ? str.slice(0, until) : str.slice(0, lastSpace)
    }

    return msg.author == "user" ?
        <div key={index} className={[styles.message, styles.user].join(" ")}><p>{msg.content}</p></div>

        : isThinking ?
            <div key={index} className={[styles.message, styles.assistant].join(" ")}>
                <div className={styles.spinner}></div>
                <div className={styles.msgContent} dangerouslySetInnerHTML={{ __html: marked.parse(msg.content) }}></div>
            </div >

            : isLast && msg.scroll && msg.content.length > msg.scroll ?
                <div key={index} className={[styles.message, styles.assistant].join(" ")}>
                    <div className={styles.msgContent} dangerouslySetInnerHTML={{ __html: marked.parse(sensitiveSubstring(msg.content, msg.scroll)) }}></div>
                    <div className={styles.moreButton} onClick={seeMore}>&darr;</div>
                </div >

                :
                <div key={index} className={[styles.message, styles.assistant].join(" ")}>
                    <div className={styles.msgContent} dangerouslySetInnerHTML={{ __html: marked.parse(msg.content) }}></div>
                </div >

}